import { render } from "./KpiSearch.vue?vue&type=template&id=4f1e9da6"
import script from "./KpiSearch.vue?vue&type=script&lang=js"
export * from "./KpiSearch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__